import React from 'react';
import LoginForm from './components/LoginForm';
import InfiniteScrollGallery from './components/InfiniteScrollGallery';

const Login: React.FC = () => {
  return (
    // <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4 w-full">
    <div className="min-h-screen bg-white flex items-center justify-center p-4 w-full">
      <div className="hidden lg:flex lg:w-2/3 bg-gray-100">
        <InfiniteScrollGallery />
      </div>
      <div className="w-full lg:w-1/3 flex justify-center items-center bg-white relative">
        <LoginForm />
      </div>
    </div>
  );  
};

export default Login;
